import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ExtendedLinkedRecord from '../ExtendedLinkedRecord';
import ListItem from '../LinkedRecordsInListMode/ListItem';
import { getParams } from '../utils';

import styles from '../../controls.less';

const LinkedRecordsInCardMode = (mainProps) => {
  const { RecordSelect, sceneId, canExpandWidth, canExpandWidthAndHeight, config, ...props } = mainProps;
  
  // expanded mode:
  // 1 in section or tab
  // has no multiselect
  // has now multiselect previously (has many items from past time)
  // const multiselect = config && config.get('multiselect');
  const expanded = ( canExpandWidth || canExpandWidthAndHeight );// && ( ! multiselect) && ( props.items && props.items.length <=1 );
  
  const extendedItems = props.items.filter(item => {
    if (!item) {
      return;
    }

    const itemData = item.get('item');
    const canRestore = item.get('canRestore');
    const removed = itemData && itemData.get('isRemoved');

    const params = getParams(item, props.controlConfig, props.remoteGroup);
    const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

    return extendedFields && !removed && !canRestore;
  });
  const simpleItems = props.items.filter(item => {
    if (!item) {
      return;
    }

    const itemData = item.get('item');
    const canRestore = item.get('canRestore');
    const removed = itemData && itemData.get('isRemoved');

    const params = getParams(item, props.controlConfig, props.remoteGroup);
    const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

    return ! (extendedFields && !removed && !canRestore );
  });

  return (
    <div
      className={cn(styles.linkedRecordsCardContainer, {
        [styles.linkedRecordsCardContainerExpanded]: expanded,
      })}
    >

      {
      // items with extended fields
      extendedItems.map((item) => {
        const itemRemovableProperty = item.getIn(['item', 'removable']);
        const itemData = item.get('item');
        const removed = itemData && itemData.get('isRemoved');

        const params = getParams(item, props.controlConfig, props.remoteGroup);
        const extendedFields = params && params.catalogId && props.extendedFields.get(params.catalogId);

        const removable = itemRemovableProperty === false ? itemRemovableProperty : !props.readOnly && !props.apiOnly;

        return (
          <ExtendedLinkedRecord
            sceneId={sceneId}
            key={item.get('key')}
            item={item}
            extFields={extendedFields}
            params={params}
            removed={removed}
            readOnly={props.readOnly}
            removable={removable}
            compact={!expanded}
            onRemoveItem={() => props.onRemoveItem && props.onRemoveItem(item)}
          />
        );
      })}

      {
      // removed & deleted items
      simpleItems.size ? (<div className={styles.linkedRecordsListWrapper}>
        {simpleItems.map((item) => {
          const params = getParams(item, props.controlConfig, props.remoteGroup);
          return (
            <ListItem
              sceneId={sceneId}
              key={item.get('key')}
              item={item}
              params={params}
              remoteGroup={props.remoteGroup}
              editable={!props.readOnly}
              onRemoveItem={() => props.onRemoveItem && props.onRemoveItem(item)}
              onRestoreItem={() => props.onRestoreItem && props.onRestoreItem(item)}
            />
          );
        })}
      </div>): null}
      {RecordSelect ? <RecordSelect.type additionalItems={props.additionalItems} {...RecordSelect.props} /> : null}
    </div>
  );
};

LinkedRecordsInCardMode.propTypes = {
  items: PropTypes.object,
  editable: PropTypes.bool,
  readOnly: PropTypes.bool,
  params: PropTypes.object,
  onClickItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
};

export default LinkedRecordsInCardMode;
